// Version : 0.0.1
// Author : SATHISH
// LastEdit : SATHISH
// MODFIED DATE:19-09-2025
//Last ADD :CODE REVIEW CHANGES AND ADD VERSION
import productTypeActionTypes from './product-type.types';

/** ***************** ADD PRODUCT TYPE DETAILS START *********************** */
export const addProductTypeDetailsStart = (addData: any) => ({
	type: productTypeActionTypes.ADD_PRODUCT_TYPE_DETAILS_START,
	payload: addData,
});

export const addProductTypeDetailsSuccess = (successData: any) => ({
	type: productTypeActionTypes.ADD_PRODUCT_TYPE_DETAILS_SUCCESS,
	payload: successData,
});

export const addProductTypeDetailsFailure = (failureData: any) => ({
	type: productTypeActionTypes.ADD_PRODUCT_TYPE_DETAILS_FAILURE,
	payload: failureData,
});

export const addProductTypeDetailsResponseResetStart = () => ({
	type: productTypeActionTypes.ADD_PRODUCT_TYPE_DETAILS_RESPONSE_RESET,
});

export const addProductTypeDetailsResponseChanged = () => ({
	type: productTypeActionTypes.ADD_PRODUCT_TYPE_DETAILS_RESPONSE_CHANGED,
});

/** ***************** ADD PRODUCT TYPE DETAILS END *********************** */

/** ***************** UPDATE PRODUCT TYPE DETAILS START *********************** */
export const updateProductTypeDetailsStart = (updateData: any) => ({
	type: productTypeActionTypes.UPDATE_PRODUCT_TYPE_DETAILS_START,
	payload: updateData,
});

export const updateProductTypeDetailsSuccess = (successData: any) => ({
	type: productTypeActionTypes.UPDATE_PRODUCT_TYPE_DETAILS_SUCCESS,
	payload: successData,
});

export const updateProductTypeDetailsFailure = (failureData: any) => ({
	type: productTypeActionTypes.UPDATE_PRODUCT_TYPE_DETAILS_FAILURE,
	payload: failureData,
});

export const updateProductTypeDetailsResponseResetStart = () => ({
	type: productTypeActionTypes.UPDATE_PRODUCT_TYPE_DETAILS_RESPONSE_RESET,
});

export const updateProductTypeDetailsResponseChanged = () => ({
	type: productTypeActionTypes.UPDATE_PRODUCT_TYPE_DETAILS_RESPONSE_CHANGED,
});

/** ***************** UPDATE PRODUCT TYPE DETAILS END *********************** */

/** ***************** GET PRODUCT TYPE LIST START *********************** */
export const getProductTypeListStart = (getData: any) => ({
	type: productTypeActionTypes.GET_PRODUCT_TYPE_LIST_START,
	payload: getData,
});

export const getProductTypeListSuccess = (successData: any) => ({
	type: productTypeActionTypes.GET_PRODUCT_TYPE_LIST_SUCCESS,
	payload: successData,
});

export const getProductTypeListFailure = (failureData: any) => ({
	type: productTypeActionTypes.GET_PRODUCT_TYPE_LIST_FAILURE,
	payload: failureData,
});

export const getProductTypeListResponseResetStart = () => ({
	type: productTypeActionTypes.GET_PRODUCT_TYPE_LIST_RESPONSE_RESET,
});

export const getProductTypeListResponseChanged = () => ({
	type: productTypeActionTypes.GET_PRODUCT_TYPE_LIST_RESPONSE_CHANGED,
});

/** ***************** GET PRODUCT TYPE LIST END *********************** */

/** ***************** FETCH PRODUCT TYPE DETAILS START *********************** */
export const fetchProductTypeDetailsStart = (fetchData: any) => ({
	type: productTypeActionTypes.FETCH_PRODUCT_TYPE_DETAILS_START,
	payload: fetchData,
});

export const fetchProductTypeDetailsSuccess = (successData: any) => ({
	type: productTypeActionTypes.FETCH_PRODUCT_TYPE_DETAILS_SUCCESS,
	payload: successData,
});

export const fetchProductTypeDetailsFailure = (failureData: any) => ({
	type: productTypeActionTypes.FETCH_PRODUCT_TYPE_DETAILS_FAILURE,
	payload: failureData,
});

export const fetchProductTypeDetailsResponseResetStart = () => ({
	type: productTypeActionTypes.FETCH_PRODUCT_TYPE_DETAILS_RESPONSE_RESET,
});

export const fetchProductTypeDetailsResponseChanged = () => ({
	type: productTypeActionTypes.FETCH_PRODUCT_TYPE_DETAILS_RESPONSE_CHANGED,
});

/** ***************** FETCH PRODUCT TYPE DETAILS END *********************** */

/** ***************** DELETE PRODUCT TYPE DETAILS START *********************** */
export const deleteProductTypeDetailsStart = (deleteData: any) => ({
	type: productTypeActionTypes.DELETE_PRODUCT_TYPE_DETAILS_START,
	payload: deleteData,
});

export const deleteProductTypeDetailsSuccess = (successData: any) => ({
	type: productTypeActionTypes.DELETE_PRODUCT_TYPE_DETAILS_SUCCESS,
	payload: successData,
});

export const deleteProductTypeDetailsFailure = (failureData: any) => ({
	type: productTypeActionTypes.DELETE_PRODUCT_TYPE_DETAILS_FAILURE,
	payload: failureData,
});

export const deleteProductTypeDetailsResponseResetStart = () => ({
	type: productTypeActionTypes.DELETE_PRODUCT_TYPE_DETAILS_RESPONSE_RESET,
});

export const deleteProductTypeDetailsResponseChanged = () => ({
	type: productTypeActionTypes.DELETE_PRODUCT_TYPE_DETAILS_RESPONSE_CHANGED,
});

/** ***************** DELETE PRODUCT TYPE DETAILS END *********************** */
